import { GetServerSideProps } from 'next';
import router from 'next/dist/client/router';
import { getDataHooksProps } from 'next-data-hooks';
import React, { useEffect } from 'react';

import { AuthGuard } from '../components/_shared/auth-guard/auth-guard';
import { HeaderFooterWrapper } from '../components/_shared/header-footer-wrapper/header-footer-wrapper';
import { RootState, useAppSelector } from '../redux';
import { AuthStrategies } from '../utils/_enums/authStrategies.enum';
import { AccountRoutePath, RoutePath } from '../utils/_enums/route-path.enum';
import { resolveLanguageAndRedirect } from '../utils/_helper/resolve-language-and-redirect-helper';
import { setHeaders } from '../utils/_helper/set-headers';
import { AuthentificationPage as LoginPage } from '../views/login/login-page';
import { AuthentificationPage as RegisterPage } from '../views/register/register-page';
import MyApp from './_app';

const AuthentificationPagePage = (): JSX.Element => {
    const jwt = useAppSelector<string>(
        (state: RootState) => state.authentification.jwt
    );

    useEffect(() => {
        if (jwt) {
            router.push(RoutePath.MY_ACCOUNT + AccountRoutePath.PROFILE);
        }
    }, [jwt]);

    return (
        <AuthGuard strategies={[AuthStrategies.UNAUTHORIZED]}>
            <RegisterPage />
        </AuthGuard>
    );
};

export default AuthentificationPagePage;

export const getServerSideProps: GetServerSideProps = async (context) => {
    setHeaders(context);

    const redirect = await resolveLanguageAndRedirect(context);

    if (redirect) return { redirect };
    const dataHooksProps = await getDataHooksProps({
        context,
        dataHooks: [
            ...HeaderFooterWrapper.dataHooks,
            ...RegisterPage.dataHooks,
            ...LoginPage.dataHooks,
            ...AuthGuard.dataHooks,
            ...MyApp.dataHooks
        ]
    });
    return {
        props: { ...dataHooksProps }
    };
};
